module.exports = __webpack_public_path__ + "static/media/doremi_00146_cursor_before.c5d96f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/doremi_00146_cursor_before.png
// module id = 226
// module chunks = 0